import { en } from './en';
import { es } from './es';

let lang: 'en' | 'es' = (localStorage.getItem('kj.lang') as 'en' | 'es') || (navigator.language.startsWith('es') ? 'es' : 'en');
export const currentLang = () => lang;
export function setLang(l: 'en' | 'es') { lang = l; localStorage.setItem('kj.lang', l); location.reload(); }

function lookup(obj: unknown, path: string): string | undefined {
  const v = path.split('.').reduce<any>((o, k) => (o == null ? undefined : o[k]), obj);
  return typeof v === 'string' ? v : undefined;
}
/** t('kiosk.welcome', { name: 'Ana' }) — Spanish → English fallback → key. */
export function t(key: string, vars?: Record<string, string | number>): string {
  const s = (lang === 'es' ? lookup(es, key) : undefined) ?? lookup(en, key) ?? key;
  return vars ? s.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? '')) : s;
}
